import React from 'react';
import SVGImage from '../layout/SVGImage';

interface SubmitButtonProps {
  text: string;
  disabled: boolean;
  submitted?: boolean;
  className?: string;
  testId?: string;
  onClick?: () => void;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  text,
  disabled,
  submitted,
  testId,
  className,
  onClick,
}) => {
  const bgSubmitted = 'disabled:bg-teal-dark disabled:text-white';
  const bgDisabled = 'disabled:bg-light-5 disabled:text-dark-10';

  return (
    <button
      type="submit"
      data-testid={testId}
      className={`noto-14-medium ${submitted ? bgSubmitted : disabled ? bgDisabled : ''} flex h-[46px] w-[151px] cursor-pointer items-center justify-center rounded-[50px] bg-teal-light leading-[24px] text-white hover:bg-teal-main ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {text}
      <SVGImage
        width={20}
        height={20}
        className="ml-[25px] fill-current"
        name={'arrow-east'}
      ></SVGImage>
    </button>
  );
};

export default SubmitButton;
